import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'association',
    'externalUrl',
    'family',
    'category',
    'product',
    'page',
  ];

  connect() {
    this.disableAll();
    const initialSelection = this.associationTarget.value;
    this.handleSelection(initialSelection);
  }

  async update_state() {
    const association = this.element.querySelector('select').value;
    this.handleSelection(association);
  }

  handleSelection(value) {
    switch (value) {
      case 'External URL':
        this.activateExternalUrl();
        break;
      case 'Family':
        this.activateFamily();
        break;
      case 'Category':
        this.activateCategory();
        break;
      case 'Product':
        this.activateProduct();
        break;
      case 'Page':
        this.activatePage();
        break;
      default:
        break;
    }
  }

  activateExternalUrl() {
    this.externalUrlTarget.disabled = false;
    this.familyTarget.disabled = true;
    this.categoryTarget.disabled = true;
    this.productTarget.disabled = true;
    this.pageTarget.disabled = true;
  }

  activateFamily() {
    this.familyTarget.disabled = false;
    this.externalUrlTarget.disabled = true;
    this.categoryTarget.disabled = true;
    this.productTarget.disabled = true;
    this.pageTarget.disabled = true;
  }

  activateCategory() {
    this.categoryTarget.disabled = false;
    this.externalUrlTarget.disabled = true;
    this.familyTarget.disabled = true;
    this.productTarget.disabled = true;
    this.pageTarget.disabled = true;
  }

  activateProduct() {
    this.productTarget.disabled = false;
    this.externalUrlTarget.disabled = true;
    this.familyTarget.disabled = true;
    this.categoryTarget.disabled = true;
    this.pageTarget.disabled = true;
  }

  activatePage() {
    this.pageTarget.disabled = false;
    this.externalUrlTarget.disabled = true;
    this.familyTarget.disabled = true;
    this.categoryTarget.disabled = true;
    this.productTarget.disabled = true;
  }

  disableAll() {
    this.externalUrlTarget.disabled = true;
    this.familyTarget.disabled = true;
    this.categoryTarget.disabled = true;
    this.productTarget.disabled = true;
    this.pageTarget.disabled = true;
  }
}
